import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { api, fmtPoints } from "../../lib/api";
import WalletCard from "../../components/WalletCard";
import { ArrowRight, ScanLine, Gift, Receipt } from "lucide-react";

export default function AccountOverview() {
    const { customer, wallet } = useAuth();
    const [txs, setTxs] = useState([]);

    useEffect(() => {
        api.get("/api/wallet/transactions?limit=5").then((r) => setTxs(r.data.transactions || []));
    }, []);

    return (
        <div className="space-y-6">
            <WalletCard customer={customer} wallet={wallet} />

            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                <ActionCard to="/account/scan" icon={ScanLine} label="Scan a bill" color="#ccff00" />
                <ActionCard to="/category/all" icon={Gift} label="Shop deals" color="#ff4d4d" />
                <ActionCard to="/account/vouchers" icon={Receipt} label="My vouchers" color="#ffd700" />
            </div>

            <section>
                <div className="flex items-center justify-between mb-3">
                    <h2 className="font-display text-lg font-semibold">Recent activity</h2>
                    <Link to="/account/wallet" className="text-xs text-[#c9a959] flex items-center gap-1">
                        See all <ArrowRight size={11} />
                    </Link>
                </div>
                <div className="space-y-2">
                    {txs.length === 0 && (
                        <div className="fx-card p-6 text-center text-[#6b7280] text-sm">
                            No transactions yet — scan your first bill to earn points!
                        </div>
                    )}
                    {txs.map((t) => (
                        <div key={t.id} className="fx-card p-3 flex items-center justify-between">
                            <div>
                                <p className="text-sm font-medium">{t.description || t.source}</p>
                                <p className="text-[11px] text-[#9ca3af]">{new Date(t.created_at).toLocaleString("en-IN")}</p>
                            </div>
                            <span className={`font-display font-bold ${t.type === "earn" ? "text-[#c9a959]" : "text-[#ff4d4d]"}`}>
                                {t.type === "earn" ? "+" : "-"}
                                {fmtPoints(t.amount_points)}
                            </span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

function ActionCard({ to, icon: Icon, label, color }) {
    return (
        <Link
            to={to}
            className="fx-card p-4 flex items-center gap-3 hover:border-[#c9a959]/40 transition-all"
        >
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${color}22`, color }}>
                <Icon size={18} />
            </div>
            <p className="text-sm font-semibold">{label}</p>
        </Link>
    );
}
